import { render, staticRenderFns } from "./FriendlyLink.vue?vue&type=template&id=36f76454&scoped=true&"
import script from "./FriendlyLink.vue?vue&type=script&lang=js&"
export * from "./FriendlyLink.vue?vue&type=script&lang=js&"
import style0 from "./FriendlyLink.vue?vue&type=style&index=0&id=36f76454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f76454",
  null
  
)

export default component.exports